/*! Haardgigant · Haardwijzer (keuzehulp). Eigen ontwerp en code van Haardgigant. */
(function () {
  'use strict';

  var RUSTIG = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var PER_KEER = 6;
  var BUDGETTEN = { tot750: { max: 75000 }, tot1500: { max: 150000 }, tot3000: { max: 300000 }, meer: { min: 250000 } };
  var NAMEN = {
    vuur: { elektrisch: 'Elektrisch', waterdamp: 'Waterdamp', bio: 'Bio-ethanol' },
    plaats: { inbouw: 'Inbouw', vrijstaand: 'Vrijstaand', inzet: 'Inzet', muur: 'Aan de muur' },
    zicht: { '1': 'Alleen van voren', '2': 'Voor en één zijkant', '3': 'Drie kanten', '4': 'Rondom of doorkijk' },
    budget: { tot750: 'Tot 750,-', tot1500: 'Tot 1.500,-', tot3000: 'Tot 3.000,-', meer: 'Meer dan 3.000,-' }
  };

  function elk(lijst, fn) { Array.prototype.forEach.call(lijst, fn); }
  function headerHoogte() {
    // het thema houdt de hoogte van de vaste header bij in --header-height
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  }
  function el(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (tekst !== undefined && tekst !== null) e.textContent = tekst;
    return e;
  }
  function nl(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
  function prijs(cent) {
    var euro = String(Math.floor(cent / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var rest = cent % 100;
    return rest ? euro + ',' + ('0' + rest).slice(-2) : euro + ',-';
  }

  /* ---------- Maten en kenmerken uit de productvelden ---------- */
  function naarCm(ruw) {
    if (ruw === null || ruw === undefined || ruw === '') return null;
    var s = String(ruw).toLowerCase().replace(/[  ]/g, ' ').replace(',', '.');
    var m = s.match(/(\d+(?:\.\d+)?)\s*(mm|cm|cn|m\b)?/);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (m[2] === 'mm') n = n / 10;
    else if (m[2] === 'm') n = n * 100;
    else if (!m[2] && n > 400) n = n / 10; // zonder eenheid: grote getallen zijn millimeters
    return n >= 10 && n <= 900 ? Math.round(n * 10) / 10 : null;
  }
  function breedteUitTitel(titel) {
    var alle = String(titel || '').match(/\d{2,3}(?:[.,]\d)?\s*cm\b/gi);
    return alle ? naarCm(alle[alle.length - 1]) : null;
  }
  function lijst(x) { return Array.isArray(x) ? x : (x ? [x] : []); }
  function vuurVan(vb) {
    var uit = {};
    lijst(vb).forEach(function (v) {
      var s = String(v).toLowerCase();
      if (s.indexOf('elektr') > -1 || s.indexOf('hologram') > -1) uit.elektrisch = true;
      if (s.indexOf('waterdamp') > -1) uit.waterdamp = true;
      if (s.indexOf('bio') > -1) uit.bio = true;
    });
    return uit;
  }
  function plaatsVan(ty) {
    var uit = {};
    lijst(ty).forEach(function (v) {
      var s = String(v).toLowerCase();
      if (s.indexOf('inbouw') > -1) uit.inbouw = true;
      if (s.indexOf('vrijstaand') > -1) uit.vrijstaand = true;
      if (s.indexOf('inzet') > -1) uit.inzet = true;
      if (s.indexOf('wand') > -1 || s.indexOf('hang') > -1) uit.muur = true;
    });
    return uit;
  }
  function zichtVan(vz, fm) {
    var uit = {};
    lijst(vz).forEach(function (v) {
      var s = String(v).toLowerCase();
      if (s.indexOf('front') > -1) uit['1'] = true;
      if (s.indexOf('2-zijdig') > -1) uit['2'] = true;
      if (s.indexOf('3-zijdig') > -1) uit['3'] = true;
      if (/4-zijdig|doorkijk|tunnel|roomdivider/.test(s)) uit['4'] = true;
    });
    if (!Object.keys(uit).length && fm) {
      var t = String(fm).toLowerCase();
      if (/front|enkelzijdig|1[\s-]*zijdig/.test(t)) uit['1'] = true;
      if (/hoek|2[\s-]*zijdig/.test(t)) uit['2'] = true;
      if (/driezijdig|3[\s-]*zijdig/.test(t)) uit['3'] = true;
      if (/vierzijdig|4[\s-]*zijdig|tunnel|doorkijk/.test(t)) uit['4'] = true;
    }
    if (!Object.keys(uit).length) uit['1'] = true; // zonder gegevens is het vrijwel altijd een fronthaard
    return uit;
  }
  function familie(merk, titel) {
    var s = String(titel || '').toLowerCase()
      .replace(/\d+(?:[.,]\d+)?\s*(?:″|"|”|inch)\s*(?:inch)?/g, ' ')
      .replace(/[-–]?\s*\d{2,3}(?:[.,]\d)?\s*cm\b/g, ' ')
      .replace(/\b\d{2,4}\b/g, ' ')
      .replace(/\s+/g, ' ').trim();
    return String(merk || '').toLowerCase() + '|' + s;
  }
  function normaliseer(p) {
    return {
      h: p.h, t: p.t, m: p.m, u: p.u, i: p.i, p: p.p || 0, c: p.c || 0, s: p.s, o: !!p.o || !p.p,
      vuur: vuurVan(p.vb), plaats: plaatsVan(p.ty), zicht: zichtVan(p.vz, p.fm),
      b: naarCm(p.b) || breedteUitTitel(p.t), hg: naarCm(p.hg), d: naarCm(p.d), fam: familie(p.m, p.t)
    };
  }

  /* ---------- Gegevens ophalen (twee pagina's van 250 producten) ---------- */
  function laadHaarden(bron) {
    var sleutel = 'hgw-haarden-1';
    try {
      var bewaard = JSON.parse(sessionStorage.getItem(sleutel) || 'null');
      if (bewaard && Date.now() - bewaard.t < 30 * 60 * 1000) return Promise.resolve(bewaard.l);
    } catch (e) { /* geen opslag beschikbaar */ }
    var verzameld = [];
    function pagina(n) {
      return fetch(bron + (bron.indexOf('?') > -1 ? '&' : '?') + 'page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.json(); })
        .then(function (d) {
          verzameld = verzameld.concat(d.producten || []);
          return n < d.paginas && n < 8 ? pagina(n + 1) : verzameld;
        });
    }
    return pagina(1).then(function (l) {
      try { sessionStorage.setItem(sleutel, JSON.stringify({ t: Date.now(), l: l })); } catch (e) { /* vol of uit */ }
      return l;
    });
  }

  /* ---------- Zoeken, sorteren en spreiden ---------- */
  // volgorde waarin keuzes worden losgelaten als er te weinig haarden overblijven
  var VERRUIMINGEN = [[], ['zicht'], ['budget'], ['zicht', 'budget'], ['plaats'], ['zicht', 'plaats'], ['zicht', 'budget', 'plaats']];
  function voldoet(p, k, los) {
    if (k.vuur && !p.vuur[k.vuur]) return false;
    if (k.plaats && !los.plaats && !p.plaats[k.plaats]) return false;
    if (k.zicht && !los.zicht && !p.zicht[k.zicht]) return false;
    if (k.ruimte && (!p.b || p.b > k.ruimte)) return false;
    if (k.hoogte && p.hg && p.hg > k.hoogte) return false;
    if (k.diepte && p.d && p.d > k.diepte) return false;
    if (k.budget && !los.budget) {
      var grens = BUDGETTEN[k.budget];
      if (p.o) return false;
      if (grens.max && p.p > grens.max) return false;
      if (grens.min && p.p < grens.min) return false;
    }
    return true;
  }
  function score(p, k) {
    var s = 0;
    if (k.ruimte) {
      // een haard die ongeveer 85 procent van de ruimte vult past het mooist
      if (p.b) s += 40 - Math.min(40, Math.abs(0.85 - p.b / k.ruimte) * 110);
      else s -= 12;
    }
    s += p.s === 'v' ? 18 : (p.s === 'n' ? 6 : 3);
    if (p.c > p.p && p.p > 0) s += 6;
    if (p.o) s -= 8;
    return s;
  }
  function spreid(rij, k) {
    // telkens de beste volgende haard, met strafpunten voor een model of merk dat al getoond is;
    // als er keuzes zijn losgelaten, gaan de haarden die wel aan alles voldoen voor
    var rest = rij.map(function (p) { return { p: p, s: score(p, k) + (voldoet(p, k, {}) ? 30 : 0) }; });
    var uit = [], model = {}, merk = {};
    while (rest.length) {
      var beste = 0, besteScore = -Infinity;
      for (var i = 0; i < rest.length; i++) {
        var kandidaat = rest[i];
        var s = kandidaat.s - 15 * (model[kandidaat.p.fam] || 0) - 4 * (merk[kandidaat.p.m] || 0);
        if (s > besteScore || (s === besteScore && kandidaat.p.p < rest[beste].p.p)) { besteScore = s; beste = i; }
      }
      var gekozen = rest.splice(beste, 1)[0].p;
      uit.push(gekozen);
      model[gekozen.fam] = (model[gekozen.fam] || 0) + 1;
      merk[gekozen.m] = (merk[gekozen.m] || 0) + 1;
    }
    return uit;
  }
  function zoek(haarden, k) {
    // plaatsing is een harde eis: liever één of twee haarden op de juiste plek dan drie op een andere
    var uitkomst = null, reserve = null;
    for (var i = 0; i < VERRUIMINGEN.length; i++) {
      var set = VERRUIMINGEN[i];
      if (set.some(function (n) { return !k[n]; })) continue;
      var los = {};
      set.forEach(function (n) { los[n] = true; });
      var gevonden = haarden.filter(function (p) { return voldoet(p, k, los); });
      var plaatsLos = set.indexOf('plaats') > -1;
      if (gevonden.length >= 3) {
        uitkomst = plaatsLos && reserve ? reserve : { lijst: gevonden, los: set };
        break;
      }
      if (!reserve && gevonden.length && !plaatsLos) reserve = { lijst: gevonden, los: set };
      uitkomst = { lijst: gevonden, los: set };
    }
    if (uitkomst.lijst.length < 3 && reserve) uitkomst = reserve;
    uitkomst.lijst = spreid(uitkomst.lijst, k);
    return uitkomst;
  }

  /* ---------- Voortgang: smalle lijn in het oranje van het logo ---------- */
  function maakLijn(houder) {
    return { zet: function (deel) { if (houder) houder.style.setProperty('--hgw-deel', String(Math.max(0, Math.min(1, deel)))); } };
  }

  /* ---------- Pagina ---------- */
  function start(root) {
    if (root.getAttribute('data-hgw-klaar')) return;
    root.setAttribute('data-hgw-klaar', '1');

    var form = root.querySelector('[data-hgw-form]');
    var omslag = root.querySelector('[data-hgw-omslag]');
    var resultaat = root.querySelector('[data-hgw-resultaat]');
    var stappen = root.querySelectorAll('.hgw__stap');
    var totaal = stappen.length;
    var lijnEl = root.querySelector('[data-hgw-lijn]');
    var lijn = maakLijn(lijnEl);
    var stapnaam = root.querySelector('[data-hgw-stapnaam]');
    var teller = root.querySelector('[data-hgw-teller]');
    var terug = root.querySelector('[data-hgw-terug]');
    var volgendeTekst = root.querySelector('[data-hgw-volgende-tekst]');
    var ruimteVeld = root.querySelector('[data-hgw-ruimte]');
    var hoogteVeld = root.querySelector('[data-hgw-hoogte]');
    var diepteVeld = root.querySelector('[data-hgw-diepte]');
    var maatChips = root.querySelectorAll('[data-hgw-maat]');
    var raster = root.querySelector('[data-hgw-raster]');
    var meerKnop = root.querySelector('[data-hgw-meer]');
    var melding = root.querySelector('[data-hgw-melding]');
    var aantal = root.querySelector('[data-hgw-aantal]');
    var keuzesLijst = root.querySelector('[data-hgw-keuzes]');
    var laden = root.querySelector('[data-hgw-laden]');
    var whatsapp = root.querySelector('[data-hgw-whatsapp]');
    var huidige = 1, timer = null, laatstePointer = 0, maatOnbekend = false;
    var gevonden = [], getoond = 0, laatsteKeuzes = null, ronde = 0;
    var haardenBelofte = null;

    function haarden() {
      if (!haardenBelofte) {
        haardenBelofte = laadHaarden(root.getAttribute('data-bron')).then(function (l) { return l.map(normaliseer); });
        haardenBelofte.catch(function () { haardenBelofte = null; });
      }
      return haardenBelofte;
    }
    setTimeout(function () { haarden().then(werkTellerBij).catch(function () {}); }, 900);

    /* stappen tonen */
    function toon(stap, scroll) {
      clearTimeout(timer);
      huidige = stap;
      var actief = null;
      elk(stappen, function (s) {
        var aan = Number(s.getAttribute('data-stap')) === stap;
        s.classList.toggle('is-actief', aan);
        if (aan) actief = s;
      });
      lijn.zet(stap / (totaal + 1));
      lijnEl.setAttribute('aria-valuenow', String(stap));
      stapnaam.innerHTML = '';
      stapnaam.appendChild(el('b', '', 'Stap ' + stap + ' van ' + totaal));
      stapnaam.appendChild(document.createTextNode(' · ' + actief.getAttribute('data-label')));
      terug.style.visibility = stap === 1 ? 'hidden' : 'visible';
      volgendeTekst.textContent = stap === totaal ? volgendeTekst.getAttribute('data-laatste') : volgendeTekst.getAttribute('data-gewoon');
      elk(root.querySelectorAll('.hgw__fout'), function (f) { f.classList.remove('is-zichtbaar'); });
      if (scroll) {
        var kaart = root.querySelector('[data-hgw-kaart]');
        var kaartTop = kaart.getBoundingClientRect().top;
        if (kaartTop < headerHoogte() || kaartTop > window.innerHeight * 0.6) kaart.scrollIntoView({ behavior: RUSTIG ? 'auto' : 'smooth', block: 'start' });
        var kop = actief.querySelector('.hgw__vraag');
        if (kop) { try { kop.focus({ preventScroll: true }); } catch (e) { kop.focus(); } }
      }
      werkTellerBij();
    }

    /* keuzetegels */
    function markeer(input) {
      var stapEl = input.closest('.hgw__stap');
      elk(stapEl.querySelectorAll('.hgw-tegel'), function (t) {
        t.classList.toggle('is-gekozen', t.querySelector('input').checked);
      });
      var fout = stapEl.querySelector('.hgw__fout');
      if (fout) fout.classList.remove('is-zichtbaar');
      werkTellerBij();
    }
    root.addEventListener('pointerdown', function () { laatstePointer = Date.now(); }, true);
    elk(root.querySelectorAll('.hgw__stap input[type=radio]:not([name="snelmaat"])'), function (input) {
      input.addEventListener('change', function () { markeer(input); });
      input.addEventListener('click', function () {
        markeer(input);
        // na een tik of klik vanzelf door; met het toetsenbord niet
        if (Date.now() - laatstePointer < 1000) {
          var stapNu = huidige;
          clearTimeout(timer);
          timer = setTimeout(function () { if (huidige === stapNu) volgende(); }, 320);
        }
      });
    });

    /* maat */
    function leesCm(waarde) {
      var s = String(waarde || '').toLowerCase().replace(/cm|\s/g, '').replace(',', '.');
      if (!/^\d+(\.\d+)?$/.test(s)) return null;
      var n = parseFloat(s);
      return n >= 30 && n <= 600 ? n : null;
    }
    function markeerChip() {
      var n = leesCm(ruimteVeld.value);
      elk(maatChips, function (c) { c.checked = n !== null && Number(c.getAttribute('data-hgw-maat')) === n; });
    }
    elk(maatChips, function (chip) {
      chip.addEventListener('click', function () {
        ruimteVeld.value = chip.getAttribute('data-hgw-maat');
        maatOnbekend = false;
        markeerChip();
        foutVoor(ruimteVeld, false);
        werkTellerBij();
      });
    });
    var maatTimer = null;
    function tellerNaTypen() { clearTimeout(maatTimer); maatTimer = setTimeout(werkTellerBij, 250); }
    ruimteVeld.addEventListener('input', function () { maatOnbekend = false; markeerChip(); foutVoor(ruimteVeld, false); tellerNaTypen(); });
    hoogteVeld.addEventListener('input', tellerNaTypen);
    diepteVeld.addEventListener('input', tellerNaTypen);
    root.querySelector('[data-hgw-maatonbekend]').addEventListener('click', function () {
      maatOnbekend = true;
      ruimteVeld.value = '';
      markeerChip();
      volgende();
    });
    var meerMaten = root.querySelector('[data-hgw-meermaten]');
    meerMaten.addEventListener('click', function () {
      var blok = root.querySelector('[data-hgw-extra]');
      blok.hidden = !blok.hidden;
      meerMaten.setAttribute('aria-expanded', String(!blok.hidden));
      if (!blok.hidden) hoogteVeld.focus();
    });
    function foutVoor(veld, aan) {
      var f = root.querySelector('#' + veld.getAttribute('aria-describedby'));
      if (f) f.classList.toggle('is-zichtbaar', aan);
      veld.setAttribute('aria-invalid', aan ? 'true' : 'false');
    }

    /* volgende en terug */
    function stapIsGoed(stapEl) {
      var radios = stapEl.querySelectorAll('input[type=radio]:not([name="snelmaat"])');
      if (radios.length) {
        var gekozen = Array.prototype.some.call(radios, function (r) { return r.checked; });
        if (!gekozen) stapEl.querySelector('.hgw__fout').classList.add('is-zichtbaar');
        return gekozen;
      }
      if (maatOnbekend) return true;
      var goed = leesCm(ruimteVeld.value) !== null;
      foutVoor(ruimteVeld, !goed);
      if (!goed) ruimteVeld.focus();
      return goed;
    }
    function volgende() {
      var stapEl = root.querySelector('.hgw__stap.is-actief');
      if (!stapIsGoed(stapEl)) return;
      if (huidige < totaal) toon(huidige + 1, true);
      else toonResultaat(keuzes(), true);
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); volgende(); });
    terug.addEventListener('click', function () { if (huidige > 1) toon(huidige - 1, true); });

    function gekozenWaarde(naam) {
      var r = form.querySelector('input[name="' + naam + '"]:checked');
      return r ? r.value : '';
    }
    function keuzes() {
      return {
        vuur: gekozenWaarde('vuur'),
        plaats: gekozenWaarde('plaats'),
        zicht: gekozenWaarde('zicht'),
        ruimte: maatOnbekend ? null : leesCm(ruimteVeld.value),
        hoogte: leesCm(hoogteVeld.value),
        diepte: leesCm(diepteVeld.value),
        budget: gekozenWaarde('budget')
      };
    }

    /* teller: hoeveel haarden passen bij de antwoorden tot nu toe */
    var getoondAantal = null, tellerFrame = null;
    function schrijfTeller(n, achter) {
      teller.innerHTML = '';
      teller.appendChild(el('b', '', String(n)));
      teller.appendChild(document.createTextNode(achter));
    }
    function zetTeller(n, beantwoord) {
      if (!teller) return;
      cancelAnimationFrame(tellerFrame);
      if (beantwoord && n === 0) { teller.textContent = 'Nog geen exacte match'; getoondAantal = 0; return; }
      var achter = beantwoord ? (n === 1 ? ' haard past' : ' haarden passen') : (n === 1 ? ' haard' : ' haarden');
      var van = getoondAantal === null ? n : getoondAantal;
      getoondAantal = n;
      if (RUSTIG || van === n) { schrijfTeller(n, achter); return; }
      var begin = null;
      function stap(t) {
        if (begin === null) begin = t;
        var f = Math.min(1, (t - begin) / 450);
        schrijfTeller(Math.round(van + (n - van) * (1 - Math.pow(1 - f, 3))), achter);
        if (f < 1) tellerFrame = requestAnimationFrame(stap);
      }
      tellerFrame = requestAnimationFrame(stap);
    }
    function werkTellerBij() {
      if (!teller || !haardenBelofte) return;
      haardenBelofte.then(function (alle) {
        var k = keuzes();
        var beantwoord = !!form.querySelector('input[type=radio]:checked:not([name="snelmaat"])') || maatOnbekend || !!k.ruimte;
        zetTeller(alle.filter(function (p) { return voldoet(p, k, {}); }).length, beantwoord);
      }).catch(function () {});
    }
    function zetKeuzes(k) {
      ['vuur', 'plaats', 'zicht', 'budget'].forEach(function (naam) {
        var r = form.querySelector('input[name="' + naam + '"][value="' + (k[naam] || '') + '"]');
        if (r) { r.checked = true; markeer(r); }
      });
      ruimteVeld.value = k.ruimte || '';
      maatOnbekend = !k.ruimte;
      hoogteVeld.value = k.hoogte || '';
      diepteVeld.value = k.diepte || '';
      if (k.hoogte || k.diepte) root.querySelector('[data-hgw-extra]').hidden = false;
      markeerChip();
    }

    /* keuzes in de adresbalk, zodat "terug" vanaf een product de uitkomst laat staan */
    function naarAdres(k) {
      var delen = [];
      ['vuur', 'plaats', 'zicht', 'ruimte', 'hoogte', 'diepte', 'budget'].forEach(function (n) { if (k[n]) delen.push(n + '=' + encodeURIComponent(k[n])); });
      try { history.replaceState(null, '', location.pathname + location.search + '#keuze&' + delen.join('&')); } catch (e) { /* oude browser */ }
    }
    function uitAdres() {
      if (location.hash.indexOf('#keuze') !== 0) return null;
      var k = {};
      location.hash.slice(1).split('&').forEach(function (deel) {
        var paar = deel.split('=');
        if (paar.length === 2) k[paar[0]] = decodeURIComponent(paar[1]);
      });
      ['ruimte', 'hoogte', 'diepte'].forEach(function (n) { k[n] = k[n] ? leesCm(k[n]) : null; });
      return k;
    }

    /* uitkomst */
    function samenvatting(k) {
      var regels = [];
      regels.push(k.vuur ? NAMEN.vuur[k.vuur] : 'Elk soort vuur');
      if (k.plaats) regels.push(NAMEN.plaats[k.plaats]);
      if (k.zicht) regels.push(NAMEN.zicht[k.zicht]);
      if (k.ruimte) regels.push('Ruimte ' + nl(k.ruimte) + ' cm');
      if (k.hoogte) regels.push('Max. ' + nl(k.hoogte) + ' cm hoog');
      if (k.diepte) regels.push('Max. ' + nl(k.diepte) + ' cm diep');
      if (k.budget) regels.push(NAMEN.budget[k.budget]);
      return regels;
    }
    function kaart(p, k) {
      var art = el('article', 'hgw-haard');
      var beeld = el('a', 'hgw-haard__beeld');
      beeld.href = p.u;
      beeld.setAttribute('tabindex', '-1');
      beeld.setAttribute('aria-hidden', 'true');
      if (p.i) {
        var img = el('img');
        img.src = p.i; img.alt = ''; img.loading = 'lazy'; img.width = 520; img.height = 390;
        beeld.appendChild(img);
      }
      var actie = p.c > p.p && p.p > 0 && !p.o;
      if (actie) beeld.appendChild(el('span', 'hgw-haard__label', Math.round((1 - p.p / p.c) * 100) + '% korting'));
      else if (p.s === 'p') beeld.appendChild(el('span', 'hgw-haard__label hgw-haard__label--rustig', 'Pre-order'));
      art.appendChild(beeld);

      var info = el('div', 'hgw-haard__info');
      info.appendChild(el('span', 'hgw-haard__merk', p.m));
      var titel = el('h3', 'hgw-haard__titel');
      var link = el('a', '', p.t); link.href = p.u;
      titel.appendChild(link);
      info.appendChild(titel);

      if (k.ruimte) {
        var pastErin = p.b && p.b <= k.ruimte;
        var past = el('p', 'hgw-haard__past' + (pastErin ? '' : ' hgw-haard__past--onbekend'));
        if (pastErin) {
          past.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
          past.appendChild(el('span', '', nl(p.b) + ' cm breed, past in je ' + nl(k.ruimte) + ' cm'));
        } else if (p.b) {
          past.textContent = nl(p.b) + ' cm breed, breder dan je ' + nl(k.ruimte) + ' cm';
        } else {
          past.textContent = 'Breedte nog niet bekend, zie de productpagina';
        }
        info.appendChild(past);
      }
      var maten = [];
      if (p.b) maten.push('B ' + nl(p.b));
      if (p.hg) maten.push('H ' + nl(p.hg));
      if (p.d) maten.push('D ' + nl(p.d));
      if (maten.length) info.appendChild(el('p', 'hgw-haard__maten', maten.join(' × ') + ' cm'));

      var prijsregel = el('p', 'hgw-haard__prijs' + (actie ? ' is-actie' : '') + (p.o ? ' hgw-haard__prijs--aanvraag' : ''));
      if (p.o) prijsregel.textContent = 'Prijs op aanvraag';
      else {
        prijsregel.appendChild(el('span', '', prijs(p.p)));
        if (actie) prijsregel.appendChild(el('s', '', prijs(p.c)));
      }
      info.appendChild(prijsregel);
      var levering = { v: ['Op voorraad', ' is-voorraad'], n: ['Wordt voor je nabesteld', ''], p: ['Pre-order', ''] }[p.s] || ['', ''];
      if (levering[0]) info.appendChild(el('p', 'hgw-haard__levering' + levering[1], levering[0]));
      var knop = el('a', root.getAttribute('data-knopklasse') || 'hgw-knop hgw-knop--hoofd', root.getAttribute('data-knoptekst') || 'Bekijk deze haard');
      knop.href = p.u;
      info.appendChild(knop);
      art.appendChild(info);
      return art;
    }
    /* de productkaart van het thema ophalen, met de pasregel erin */
    function pasregel(p, k) {
      if (!k.ruimte) return null;
      var pastErin = p.b && p.b <= k.ruimte;
      var tekst = pastErin ? 'Past in je ruimte: ' + nl(p.b) + ' cm breed'
        : (p.b ? nl(p.b) + ' cm breed, breder dan je ' + nl(k.ruimte) + ' cm' : 'Breedte staat op de productpagina');
      return el('p', 'hgw-past text-sm' + (pastErin ? '' : ' hgw-past--niet'), tekst);
    }
    function themakaart(p, k) {
      var adres = p.u + (p.u.indexOf('?') > -1 ? '&' : '?') + 'section_id=hg-haardwijzer-kaart';
      return fetch(adres, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
        .then(function (html) {
          var tijdelijk = document.createElement('div');
          tijdelijk.innerHTML = html;
          var sectie = tijdelijk.querySelector('.shopify-section') || tijdelijk;
          var li = document.createElement('li');
          li.innerHTML = sectie.innerHTML.trim();
          if (!li.querySelector('.card')) throw new Error('geen kaart');
          var regel = pasregel(p, k);
          var titel = li.querySelector('.card__title');
          if (regel && titel) titel.parentNode.insertBefore(regel, titel.nextSibling);
          return li;
        })
        .catch(function () {
          var li = document.createElement('li');
          li.appendChild(kaart(p, k));
          return li;
        });
    }
    function toonMeer() {
      var deel = gevonden.slice(getoond, getoond + PER_KEER);
      var dezeRonde = ronde;
      getoond += deel.length;
      meerKnop.hidden = true;
      return Promise.all(deel.map(function (p) { return themakaart(p, laatsteKeuzes); })).then(function (items) {
        if (dezeRonde !== ronde) return; // intussen zijn de keuzes aangepast
        items.forEach(function (li) { raster.appendChild(li); });
        meerKnop.hidden = getoond >= gevonden.length;
      });
    }
    meerKnop.addEventListener('click', toonMeer);

    function zetMelding(uitkomst, k) {
      var teksten = [];
      if (uitkomst.teKlein) {
        teksten.push('Geen haard met deze keuzes past in ' + nl(k.ruimte) + ' cm. Hieronder de smalste haarden die het meest in de buurt komen. Twijfel je over de maat? Bel ons, dan denken we mee.');
      } else if (uitkomst.los.length) {
        var namen = { zicht: 'het vuurzicht', budget: 'je budget', plaats: 'de plaatsing' };
        teksten.push('Er zijn weinig haarden die precies aan alles voldoen. Daarom zie je ook haarden die afwijken op ' + uitkomst.los.map(function (n) { return namen[n]; }).join(' of ') + '.');
      }
      melding.textContent = teksten.join(' ');
      melding.hidden = !teksten.length;
    }
    function zetWhatsapp(k) {
      if (!whatsapp) return;
      var nummer = whatsapp.getAttribute('data-nummer');
      var tekst = (whatsapp.getAttribute('data-bericht') || '') + ' ' + samenvatting(k).join(', ') + '.';
      var top = gevonden.slice(0, 3).map(function (p) { return p.t; });
      if (top.length) tekst += ' Deze spraken me aan: ' + top.join('; ') + '.';
      whatsapp.href = 'https://wa.me/' + nummer + '?text=' + encodeURIComponent(tekst);
    }

    function toonResultaat(k, scroll) {
      ronde++;
      laatsteKeuzes = k;
      naarAdres(k);
      omslag.hidden = true;
      resultaat.hidden = false;
      keuzesLijst.innerHTML = '';
      samenvatting(k).forEach(function (r) { keuzesLijst.appendChild(el('li', '', r)); });
      raster.innerHTML = '';
      meerKnop.hidden = true;
      melding.hidden = true;
      aantal.textContent = '';
      laden.hidden = false;
      if (scroll) resultaat.scrollIntoView({ behavior: RUSTIG ? 'auto' : 'smooth', block: 'start' });
      haarden().then(function (alle) {
        var uitkomst = zoek(alle, k);
        if (!uitkomst.lijst.length && k.ruimte) {
          var zonderMaat = {}; for (var n in k) zonderMaat[n] = k[n];
          zonderMaat.ruimte = null; zonderMaat.hoogte = null; zonderMaat.diepte = null;
          uitkomst = zoek(alle, zonderMaat);
          uitkomst.lijst.sort(function (a, b) { return (a.b || 999) - (b.b || 999); });
          uitkomst.teKlein = true;
        }
        gevonden = uitkomst.lijst;
        getoond = 0;
        var precies = !uitkomst.teKlein && !uitkomst.los.length;
        aantal.textContent = gevonden.length === 1
          ? (precies ? '1 haard' : '1 haard die het dichtst in de buurt komt')
          : gevonden.length + (precies ? ' haarden, de best passende bovenaan' : ' haarden die het dichtst in de buurt komen');
        zetMelding(uitkomst, k);
        zetWhatsapp(k);
        return toonMeer().then(function () { laden.hidden = true; });
      }).catch(function () {
        laden.hidden = true;
        melding.textContent = 'De haarden konden niet worden geladen. Probeer het opnieuw of bekijk alle haarden in de winkel.';
        melding.hidden = false;
      });
    }
    root.querySelector('[data-hgw-opnieuw]').addEventListener('click', function () {
      ronde++;
      resultaat.hidden = true;
      omslag.hidden = false;
      toon(1, true);
    });

    var vanAdres = uitAdres();
    if (vanAdres) { zetKeuzes(vanAdres); toonResultaat(vanAdres, false); }
    else toon(1, false);
  }

  function alles() { elk(document.querySelectorAll('[data-hgw]'), start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles);
  else alles();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-hgw]');
    if (r) start(r);
  });
})();
